import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from "vuetify/lib/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#256c74",
        secondary: "#24cad4",
        "secondary-light": "#24cad4",
        accent: "#EA3323",
        error: "#EA3323",
        info: "#2196F3",
        success: "#24cad4",
        warning: "#da5736",
        lightGray: "#e3e3e3"
      }
    }
  },
  lang: {
    locales: { es },
    current: "es"
  }
});
